import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=d97fd3c6&scoped=true&"
import script from "./Apps.vue?vue&type=script&lang=ts&"
export * from "./Apps.vue?vue&type=script&lang=ts&"
import style0 from "./Apps.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./Apps.vue?vue&type=style&index=1&id=d97fd3c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97fd3c6",
  null
  
)

export default component.exports